import { Button } from '@themesberg/react-bootstrap';
import React from 'react'

export const TableRow = (props) => {
  const { gamePeriod, analytic, result, status, totalTickets, totalRewaredTickets, totalUnRewardTickets, onCalculateRewardPress, onConfirmNumberTicket, onShowPeriodPress } = props;

  const notHaveResultYet = <td className="text-warning">{"Chưa có kết quả"}</td>

  const cannotGetResult = <td className="text-danger">{"Không lấy được kết quả"}</td>

  let resultTd = notHaveResultYet

  if (result && result.length > 0 && analytic) {
    resultTd = <td>
      <h5 className={"text-primary"}>{result}</h5>
      <span className={analytic.Even === 1 || analytic.IsEven1112 === 1 ? "text-danger" : "text-info"}> Chẵn ({analytic.TotalEven}) </span> &nbsp;
      <span className={analytic.Odd === 1 || analytic.IsOdd1112 === 1 ? "text-danger" : "text-info"}> Lẻ ({analytic.TotalOdd}) </span> &nbsp; | &nbsp;
      <span className={analytic.Upper === 1 ? "text-danger" : "text-info"}> Lớn ({analytic.TotalUpper}) </span> &nbsp;
      <span className={analytic.Lower === 1 ? "text-danger" : "text-info"}> Nhỏ ({analytic.TotalLower}) </span> &nbsp;
    </td>
  } else {
    if (status === 1) {
      resultTd = cannotGetResult
    }
  }

  const hasResult = result && result.length > 0 && analytic

  return (
    <tr>
      <td>
        {hasResult &&
          <Button variant="info" className="m-1" onClick={() => onCalculateRewardPress(gamePeriod)}>Tính thưởng</Button>
        }
      </td>
      <td>
        <b>{'#' + gamePeriod.name || ""}</b><br />
        {gamePeriod.resultDate}<br />
        <span className="text-info">{gamePeriod.resultTime}</span>
      </td>
      <td>
        Tổng số vé: <b className='text-info'>{totalRewaredTickets + totalUnRewardTickets}</b><br />
        Trúng thưởng: <b className='text-success'>{totalRewaredTickets}</b><br />
        Không trúng thưởng: <b className='text-danger'>{totalUnRewardTickets}</b><br />
      </td>
      {resultTd}
      <td className='text-center'>
        {totalTickets !== 0 &&
          <Button variant="warning" className="m-1" onClick={() => onShowPeriodPress(gamePeriod)}>Xem thống kê</Button>
        }
        {totalTickets === 0 && <Button variant="warning" className="m-1" onClick={() => onConfirmNumberTicket(gamePeriod.id, totalRewaredTickets + totalUnRewardTickets === 0 ? -1 : totalRewaredTickets + totalUnRewardTickets)}>Xong</Button>}
      </td>
    </tr>
  );
};